import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@workspace/web-ui/components/select"



interface FilterProps {
    label: string
    options: {
        label: string
        value: string
    }[]
    value: string
    onValueChange: (value: string) => void
    placeholder?: string
}


const Filter = ({ label, options, value, onValueChange, placeholder }: FilterProps) => {
    const selectedOption = options.find(option => option.value === value);
    const displayValue = selectedOption?.value === "all" || !selectedOption 
        ? (placeholder || label)
        : selectedOption.label;
    
    return (
        <Select value={value} onValueChange={onValueChange}>
            <SelectTrigger className="w-[150px] select h-fit">
                <SelectValue>
                    {displayValue}
                </SelectValue>
            </SelectTrigger>
            <SelectContent className="w-[200px]">
                {options.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                        {option.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    )
}


export default Filter